/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class AppApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * 
     * @param redirect 
     */
    public lookupRedirect(redirect?: string, __unused?: any): Observable<{}> {
        const path = '/app/redirects/{redirect}'
                    .replace('{' + 'redirect' + '}', String(redirect));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<any>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Get status of the frontend application
     * @param version 
     * @param app 
     */
    public getStatus(version?: string, app?: string, __unused?: any): Observable<models.ApiAppConfig> {
        const path = '/app/config/{app}'
                    .replace('{' + 'app' + '}', String(app));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (version !== undefined) {
            queryParameters['version'] = <any>version;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiAppConfig>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
